<div class="payee-details-wrapper detail-wrapper">
  <div class="payee-header">Payer details</div>
  <ng-container *ngFor="let field of config">
    <div class="detail-column detail" [ngClass]="{'email': field.elementKey === 'email'}" *ngIf="field.elementKey === 'paymentType' ? paymentType : payee[field.elementKey]">
      <label class="detail-label"  *ngIf="field.elementKey !== 'paymentType'">{{field.config.displayName}}</label>
      <div class="detail-info ellipsis" *ngIf="field.elementKey !== 'paymentType'" title="{{payee[field.elementKey]}}">{{payee[field.elementKey]}}</div>
      <!-- <div class="detail-info ellipsis" *ngIf="field.elementKey === 'paymentType'" [title]="paymentType">{{paymentType}}</div> -->
    </div>
  </ng-container>
</div>

